const REACT_APP_OKTA_CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID;
const REACT_APP_OKTA_ISSUER = process.env.REACT_APP_OKTA_ISSUER;
const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;

export const oktaConfig = {
  clientId: REACT_APP_OKTA_CLIENT_ID ? REACT_APP_OKTA_CLIENT_ID : '',
  issuer: REACT_APP_OKTA_ISSUER ? REACT_APP_OKTA_ISSUER : '',
  redirectUri: REACT_APP_BASE_URL + '/login/callback',
  scopes: ['openid', 'email',"pepappdwdstatus","pepappdwdroles"],
  pkce: true,
  disableHttpsCheck: false,
};
